import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api/integrations/telegram`;

const auth = token => ({ headers: token ? { Authorization: `Bearer ${token}` } : {} });

/** Admin → Integrations → Telegram. The bot token is write-only: the server never sends it back. */
export const getTelegram = async token => (await axios.get(API, auth(token))).data;
export const saveTelegram = async (body, token) => (await axios.put(API, body, auth(token))).data;
export const addChat = async (body, token) => (await axios.post(`${API}/chats`, body, auth(token))).data;
export const updateChat = async (id, body, token) => (await axios.patch(`${API}/chats/${id}`, body, auth(token))).data;
export const removeChat = async (id, token) => (await axios.delete(`${API}/chats/${id}`, auth(token))).data;
export const sendTest = async (chatId, token) => (await axios.post(`${API}/test`, { chat_id: chatId }, auth(token))).data;
export const recentChats = async token => (await axios.get(`${API}/updates`, auth(token))).data;
// A one-time QR / t.me invitation for a person, and disconnecting them (People).
export const createLinkCode = async (userId, token) => (await axios.post(`${API}/links/code`, { user_id: userId }, auth(token))).data;
export const removeLink = async (id, token) => (await axios.delete(`${API}/links/${id}`, auth(token))).data;

// Phase 1 (owner PRD §11, 2026-10-31)
export const telegramOverview = async token => (await axios.get(`${API}/overview`, auth(token))).data;
export const telegramItems = async token => (await axios.get(`${API}/items`, auth(token))).data;
export const telegramPeople = async token => (await axios.get(`${API}/people`, auth(token))).data;
export const setTelegramSwitches = async (linkId, changes, token) =>
  (await axios.put(`${API}/people/${linkId}/switches`, { changes }, auth(token))).data;
export const resetTelegramSwitches = async (linkId, token) =>
  (await axios.post(`${API}/people/${linkId}/reset`, null, auth(token))).data;
export const telegramInvitations = async token => (await axios.get(`${API}/invitations`, auth(token))).data;
export const revokeTelegramInvitation = async (id, token) =>
  (await axios.post(`${API}/invitations/${id}/revoke`, null, auth(token))).data;
export const linkMyTelegram = async token => (await axios.post(`${API}/me/link`, null, auth(token))).data;
export const myTelegramLink = async token => (await axios.get(`${API}/me/link`, auth(token))).data;
export const telegramDelivery = async (status, token) =>
  (await axios.get(`${API}/delivery`, { ...auth(token), params: status ? { status } : {} })).data;
export const retryTelegramMessage = async (id, token) => (await axios.post(`${API}/delivery/${id}/retry`, null, auth(token))).data;
export const telegramAudit = async token => (await axios.get(`${API}/audit`, auth(token))).data;

// Brand Bible §67 — AI Assistant MCP Access
const MCP_BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api/integrations`;
export const listApiTokens = async token => (await axios.get(`${MCP_BASE}/tokens`, auth(token))).data;
export const createApiToken = async (body, token) => (await axios.post(`${MCP_BASE}/tokens`, body, auth(token))).data;
export const revokeApiToken = async (id, token) => (await axios.delete(`${MCP_BASE}/tokens/${id}`, auth(token))).data;
export const listMcpTools = async token => (await axios.get(`${MCP_BASE}/mcp/tools`, auth(token))).data;
